define('formkit/view/form.object/rule/rules.composite.view',['require','underscore','backbone','uikit/uikit','../../../templates','./rule.item.view','../../../model/rule.model'],function (require) {
  var _            = require('underscore');
  var Backbone     = require('backbone');
  var UIKit        = require('uikit/uikit');
  var Templates    = require('../../../templates');
  var RuleItemView = require('./rule.item.view');
  var RuleModel    = require('../../../model/rule.model');


  var RulesCompositeView = UIKit.CompositeView.extend({

    template: Templates.App['rules.composite'],

    childView: RuleItemView,

    childViewOptions: function (model, index) {
      return {
        collection: model.get('conditions'),
        form: this.getOption('form'),
        index: index + 1
      }
    },

    filter: function(child, index, collection) {
      return !child.get('hidden') && child.get('action') == 'displayed';
    },

    childViewContainer: '.rulesContainer',

    internalViewOptions: {
      descriptionTextView: {
        type: UIKit.Text,
        text: 'Display this object if any of the following rule groups are fulfilled:'
      },
      descriptionDividerView: {
        type: UIKit.Divider,
        hidden: true
      },
      addRuleButtonDividerView: function() {
        return {
          type: UIKit.Divider,
          hidden: true,
          visible: !this.isEmpty()
        }
      },
      addRuleButtonView: {
        type: UIKit.Button,
        icon: 'plus',
        color: 'primary',
        text: 'Add Rule Group'
      }
    },

    collectionEvents: {
      "add remove": "updateAddRuleButtonDividerViewVisibility"
    },

    onChildviewRemoveRule: function(ruleView, ruleModel) {
      this.removeRuleFromCollection(ruleModel);
    },

    onAddRuleButtonViewPress: function () {
      this.addRuleToCollection();
    },

    addRuleToCollection: function (model) {
      this.collection.add({conditions: [{}]});
    },

    removeRuleFromCollection: function (model) {
      this.collection.remove(model);
    },

    onUpdateIndices: function() {
      this.children.each(function(child) {
        child.index = child._index + 1;
      })
    },

    updateAddRuleButtonDividerViewVisibility: function() {
      this.addRuleButtonDividerView.visible = !this.isEmpty();
    },

    //overriding update indices function
    _updateIndices: function(view, increment, index) {
      UIKit.CompositeView.prototype._updateIndices.call(this, view, increment, index);

      this.triggerMethod('update:indices');
    },

    // overriding current isEmpty to allow for filetered functionality (upgrade to Marionette 3 and remove this stuff as well as 2 functions below)
    isEmpty: function isEmpty(options) {
	    var models = void 0;
	    if (_.result(options, 'processedModels')) {
	      models = options.processedModels;
	    } else {
	      models = this.collection ? this.collection.models : [];
	      models = this._filterModels(models);
	    }
	    return models.length === 0;
	  },

    _filterModels: function _filterModels(models) {
	    var _this5 = this;

	    if (this.filter) {
	      models = _.filter(models, function (model, index) {
	        return _this5._shouldAddChild(model, index);
	      });
	    }
	    return models;
	  },

    _shouldAddChild: function _shouldAddChild(child, index) {
	    var filter = this.filter;
	    return !_.isFunction(filter) || filter.call(this, child, index, this.collection);
	  }

  });

  return RulesCompositeView;

});

